import { Link } from "react-router-dom";

const features = [
  { icon: "ri-image-2-line", title: "资料详实", desc: "导演、主演、地区、年份与集数一次看全" },
  { icon: "ri-filter-3-line", title: "多维筛选", desc: "类型、地区、年份组合过滤，按热度或评分排序" },
  { icon: "ri-heart-3-line", title: "本地收藏", desc: "无需登录，收藏状态保存在当前浏览器" },
];

export default function IntroSection() {
  return (
    <section className="w-full px-4 pb-4 md:px-6">
      <div className="relative overflow-hidden rounded-lg bg-primary-500 px-5 py-10 md:px-10 md:py-12">
        <div className="pointer-events-none absolute -right-20 -top-24 h-64 w-64 rounded-full border border-background-50/10" />
        <div className="pointer-events-none absolute -bottom-28 right-16 h-72 w-72 rounded-full border border-background-50/10" />
        <div className="relative grid grid-cols-1 gap-8 lg:grid-cols-2 lg:items-center">
          <div>
            <p className="font-label text-[11px] uppercase tracking-[0.24em] text-accent-400">About 97 Video</p>
            <h2 className="mt-3 font-heading text-xl font-bold leading-snug text-background-50 md:text-2xl">
              一个专注影视资料整理的内容聚合平台
            </h2>
            <p className="mt-3 max-w-lg text-[13px] leading-relaxed text-background-50/70">
              97视频把散落在各处的电影、电视剧与综艺资料，按统一的字段重新整理：一张海报、一份演职员表、一段剧情简介，以及清晰的更新节奏。我们相信，找到一部想看的作品，不该比看完它更费劲。
            </p>
            <div className="mt-6 flex flex-wrap gap-3">
              <Link
                to="/about"
                className="flex items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-4 py-2.5 text-[13px] font-semibold text-background-50 transition-colors hover:bg-accent-600"
              >
                了解平台
                <i className="ri-arrow-right-line flex h-4 w-4 items-center justify-center" />
              </Link>
              <Link
                to="/search"
                className="flex items-center gap-2 whitespace-nowrap rounded-md border border-background-50/30 px-4 py-2.5 text-[13px] text-background-50 transition-colors hover:bg-background-50/10"
              >
                搜索影视
              </Link>
            </div>
          </div>
          <div className="grid grid-cols-1 gap-3 sm:grid-cols-3">
            {features.map((feature) => (
              <div key={feature.title} className="rounded-lg border border-background-50/15 bg-background-50/5 p-4">
                <span className="flex h-9 w-9 items-center justify-center rounded-md bg-background-50/10 text-accent-300">
                  <i className={`${feature.icon} text-base`} />
                </span>
                <h3 className="mt-3 font-heading text-[13px] font-semibold text-background-50">{feature.title}</h3>
                <p className="mt-1.5 text-[11px] leading-relaxed text-background-50/60">{feature.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}